import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup,
  Snackbar,
  TextField,
  Typography,
} from '@mui/material';
import Header from '../../components/Header';
import { Link, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { useTheme } from '@emotion/react';
import { tokens } from '../../theme';

const AddCountry = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastmessage] = useState('');

  const token = localStorage.getItem('token');

  const [values, setValues] = useState({
    name: '',
    description: '',
    duration: '',
    type: '',
    url: '',
    image: '',
    status: '',
    discount: '',
    discountMessage: '',
  });
  const [image, setImage] = useState(false);

  const imageHandler = (e) => {
    setImage(e.target.files[0]);
  };

  const handleChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (
      values.name === '' ||
      values.description === '' ||
      values.type === '' ||
      values.duration === '' ||
      values.status === '' ||
      !image
    ) {
      setOpenToast(true);
      setToastmessage('Please fill all details and select an image');
      return;
    }
    {
      const formData = new FormData();
      formData.append('file', image);

      try {
        const res = await fetch(`${process.env.REACT_APP_APILINK}/country/uploadimage`, {
          headers: { token },
          method: 'POST',
          body: formData,
        });
        const imageData = await res.json();

        if (imageData.message) {
          setOpenToast(true);
          setToastmessage(imageData.message);
        }
        if (imageData.success) {
          values.image = imageData.image;

          const res = await fetch(`${process.env.REACT_APP_APILINK}/country/addcountry`, {
            method: 'POST',
            headers: {
              'Content-type': 'application/json',
              token,
            },
            body: JSON.stringify(values),
          });
          const data = await res.json();

          if (data.message) {
            setOpenToast(true);
            setToastmessage(data.message);
            if (data.success) {
              setTimeout(() => {
                navigate('/countries');
              }, 2000);
            }
          }
        }
      } catch (error) {
        console.log(error);
        setOpenToast(true);
        setToastmessage('Something went wrong. Please try again');
      }
    }
  };

  // Toast
  const handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenToast(false);
  };

  const action = (
    <>
      <IconButton size="small" aria-label="close" color="inherit" onClick={handleCloseToast}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </>
  );

  return (
    <Box m="20px">
      <Box display="flex" justifyContent="space-between" alignItems="center" rowGap="10px" flexWrap="wrap-reverse">
        <Header title="ADD DESTINATION" subtitle="Add a New Destination Location" />

        <Box>
          <Link to={-1}>
            <Button
              sx={{
                backgroundColor: colors.blueAccent[700],
                color: colors.grey[100],
                fontSize: '14px',
                fontWeight: 'bold',
                padding: '10px 20px',
                '&:hover': {
                  backgroundColor: colors.blueAccent[800],
                },
              }}
            >
              Go Back
            </Button>
          </Link>
        </Box>
      </Box>

      <form onSubmit={handleFormSubmit}>
        <Box
          style={{
            display: 'grid',
            gap: '10px',
          }}
        >
          <TextField
            fullWidth
            variant="filled"
            type="text"
            label="Name"
            onChange={handleChange}
            value={values.name}
            name="name"
            required
          />

          <TextField
            fullWidth
            variant="filled"
            type="text"
            label="Description"
            onChange={handleChange}
            value={values.description}
            name="description"
            required
          />

          <TextField
            fullWidth
            variant="filled"
            type="text"
            label="Duration"
            onChange={handleChange}
            value={values.duration}
            name="duration"
            required
          />

          <TextField
            fullWidth
            variant="filled"
            type="text"
            label="Type"
            onChange={handleChange}
            value={values.type}
            name="type"
            required
          />

          <TextField
            fullWidth
            variant="filled"
            type="text"
            label="URL"
            onChange={handleChange}
            value={values.url}
            name="url"
            required
          />

          <TextField
            fullWidth
            variant="filled"
            multiline
            minRows={2}
            label="Discount message"
            onChange={handleChange}
            value={values.discountMessage}
            name="discountMessage"
            placeholder="By choosing an excursion package, you save up to {amount} EUR."
          />

          <TextField
            fullWidth
            variant="filled"
            type="number"
            label="Discount (EUR)"
            onChange={handleChange}
            value={values.discount}
            name="discount"
            placeholder="e.g. 50"
            inputProps={{ min: 0, step: 0.01 }}
          />

          <Typography variant="h5" mt="10px" color={colors.grey[100]}>
            Add Destination Image
          </Typography>
          <label
            htmlFor="file-input"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '10px',
              padding: '15px',
              background: colors.primary[400],
              fontSize: '18px',
              fontWeight: 'bold',
              cursor: 'pointer',
              borderRadius: '10px',
              width: '100%',
              maxWidth: '400px',
              aspectRatio: '16/9',
            }}
          >
            {image ? (
              <img
                src={URL.createObjectURL(image)}
                className="addproduct-thumbnail-img"
                alt="Image Upload"
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            ) : (
              <>
                <CloudUploadIcon fontSize="large" /> Upload Image
              </>
            )}
          </label>
          <input type="file" accept="image/*" onChange={imageHandler} name="image" id="file-input" hidden />

          <FormControl component="fieldset">
            <Typography variant="h5" mt="10px" color={colors.grey[100]}>
              Status
            </Typography>
            <RadioGroup
              aria-label="status"
              name="status"
              value={values.status}
              onChange={(e) => setValues({ ...values, status: e.target.value })}
              row
            >
              <FormControlLabel value="active" control={<Radio color="success" />} label="Active" />
              <FormControlLabel value="inactive" control={<Radio color="success" />} label="Inactive" />
            </RadioGroup>
          </FormControl>

          <Button
            type="submit"
            sx={{
              backgroundColor: colors.blueAccent[700],
              color: colors.grey[100],
              width: 'fit-content',
              fontSize: '14px',
              fontWeight: 'bold',
              padding: '10px 30px',
              '&:hover': {
                backgroundColor: colors.blueAccent[800],
              },
            }}
          >
            Submit
          </Button>
        </Box>
      </form>

      <Snackbar
        open={openToast}
        autoHideDuration={5000}
        onClose={handleCloseToast}
        message={toastMessage}
        action={action}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      />
    </Box>
  );
};

export default AddCountry;
